var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGzTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-pin"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 1",
    cx: 15.9996,
    cy: 14.6667,
    rx: 14.2222,
    ry: 14.2222,
    fill: "#6AD67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.2396 11.3997C24.2396 11.4358 24.2157 11.4631 24.1811 11.4695L20.3866 12.0194C20.594 12.7113 20.8287 13.7678 20.5497 15.0189C20.315 16.0685 19.7451 16.938 18.9007 17.5339C18.0126 18.1594 17.0552 18.3359 16.3825 18.3103L12.022 22.7816H9.66797L14.4528 17.8758C13.7125 17.5711 12.9971 17.1151 12.376 16.5379C9.45035 13.8249 9.4583 9.96221 10.0026 7.20496L16.9671 13.5075V15.7149L11.3919 10.6699C11.4476 11.9774 11.8556 13.8243 13.4562 15.3119C14.5221 16.3014 15.8722 16.8058 16.9808 16.6241C17.995 16.4593 18.7587 15.712 18.9735 14.6747C19.2116 13.5238 18.8615 12.4842 17.9376 11.6717L19.0047 10.579L24.1816 11.3309C24.2163 11.3356 24.2402 11.3641 24.2402 11.3997H24.2396Z",
    fill: "#FFFDFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M15.8057 30.7418L12.2988 28.0376L15.8057 25.3334L19.3125 28.0376L15.8057 30.7418Z",
    fill: "#6AD67D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGzTop);
export default __webpack_public_path__ + "static/media/gz-top.800270bb935e35530e7dd052619fa6e6.svg";
export { ForwardRef as ReactComponent };